import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnTableButtonComponent} from './table-button.component';
import {GnModalButtonModule} from '../modal-button/modal-button.module';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';


@NgModule({
  declarations: [GnTableButtonComponent],
  exports: [
    GnTableButtonComponent
  ],
  imports: [
    CommonModule,
    NzButtonModule,
    NzIconModule,
    GnModalButtonModule
  ]
})
export class GnTableButtonModule {
}
